// @flow
import * as React from 'react'

import './BoldText.scss'

type Props = {
  children: React.Node,
}

export default class BoldText extends React.Component<Props> {
  render = () => {
    return <span className="BoldText">{this.props.children}</span>
  }
}
